import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import fetcher from "../modules/fetcher";
import { TextField, MenuItem } from "@material-ui/core";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({}));

export default function selectorBase(props) {
  const classes = useStyles();

  function getBaseByID(baseID) {
    const found = props.items.filter((base) => {
      return String(_.get(base, "_id")) === String(baseID);
    });
    return _.size(found) > 0 ? found[0] : null;
  }

  if (_.size(props.items) > 0 && _.has(props, "selectedItem._id"))
    return (
      <div id="selectorBase">
        <TextField
          id="selectorBase_textField"
          select
          value={props.selectedItem._id}
          onChange={(event) => {
            props.setSelectedModifiedBase(null);
            if (!_.isNil(props.selectedVersion) && !_.isNil(_.get(props, "selectedVersion._id")) && props.userPermissions["editContent"]) {
              const persist =
                typeof props.persistVersionBeforeSwitch === "function"
                  ? props.persistVersionBeforeSwitch(props.selectedVersion)
                  : Promise.resolve();

              persist
                .then(() => {
                  props.setSelectedItem(getBaseByID(event.target.value));
                })
                .catch((err) => {
                  console.error(err);
                  props.setSelectedItem(getBaseByID(event.target.value));
                });
            } else {
              props.setSelectedItem(getBaseByID(event.target.value));
            }
          }}
        >
          {props.items.map((base) => (
            <MenuItem id="selectorBase_popup" key={String(base._id)} value={String(base._id)}>
              {" "}
              {String(base.title)}
            </MenuItem>
          ))}
        </TextField>
      </div>
    );
  else return null;
}
